import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { ContainersView } from '@/react/edge/edge-devices/ContainersView';
import { StacksView } from '@/react/edge/edge-devices/StacksView';
import { ContainerView } from '@/react/edge/edge-devices/ContainerView';
import { DashboardView } from '@/react/edge/edge-devices/DashboardView';
import { ImagesView } from '@/react/edge/edge-devices/ImagesView';
import { LogView } from '@/react/edge/edge-devices/LogView/LogView';
import { MTLSCertificateView } from '@/react/edge/edge-devices/MTLSCertificateView';
import { VolumesView } from '@/react/edge/edge-devices/VolumesView';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { WaitingRoomView } from '@/react/edge/edge-devices/WaitingRoomView';

import { templatesModule } from './templates';
import { configurationsModule } from './configurations';
import { jobsModule } from './jobs';
import { stacksModule } from './edge-stacks';
import { groupsModule } from './groups';

export const viewsModule = angular
  .module('portainer.edge.react.views', [
    configurationsModule,
    templatesModule,
    jobsModule,
    stacksModule,
    groupsModule,
  ])
  .component(
    'waitingRoomView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(WaitingRoomView))), [])
  )
  .component(
    'edgeDeviceDashboardView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(DashboardView))), [])
  )
  .component(
    'edgeDeviceMTLSCertificateView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(MTLSCertificateView))), [])
  )
  .component(
    'edgeDeviceStacksView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(StacksView))), [])
  )
  .component(
    'edgeDeviceContainersView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(ContainersView))), [])
  )
  .component(
    'edgeDeviceContainerView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(ContainerView))), [])
  )
  .component(
    'edgeDeviceContainerLogsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(LogView))), [])
  )

  .component(
    'edgeDeviceImagesView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(ImagesView))), [])
  )
  .component(
    'edgeDeviceVolumesView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(VolumesView))), [])
  ).name;
